import './about-box.scss'

export default {
    name: 'about-box',

    data: {
        observer: null
    },

    mounted () {
        this.observer = new IntersectionObserver(entries => {
            _.each(entries, entry => {
                if (entry.isIntersecting && entry.target.classList.contains('hidden')) {
                    entry.target.classList.remove('hidden')
                }
            })
        }, {
            rootMargin: '-10%'
        })

        this.observer.observe(this.$el)
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/about-box/about-box.js